export default {
    pending: 'created',
    inProgress: 'inProgress',
    uploaded: 'uploaded',
    received: 'received',
    processed: 'completed',
    empty: 'empty'
}